import { render, staticRenderFns } from "./Authorization.view.vue?vue&type=template&id=259dbc84&"
import script from "./Authorization.view.vue?vue&type=script&lang=js&"
export * from "./Authorization.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports